// src/components/common/TransitionLoader.jsx

import React from 'react';
import Spinner from '../loadingSpinnercomponent/Spinner'; // Adjust the path as needed
import './TransitionLoader.css';

const TransitionLoader = ({ message }) => (
  <div className="transition-loading" role="alert" aria-live="assertive">
    <Spinner />
    {message && <p>{message}</p>}
  </div>
);

export default TransitionLoader;
